import { Box, Flex, Text } from '@chakra-ui/react'
import { useRouter } from 'next/router'
import React from 'react'
import { Button } from 'components/Button'
import { Routes } from 'constants/routes'
import { useThemeColors } from 'hooks/useThemeColors'

type UnverifiedContractProps = {
  bytecode: string
}

export const UnverifiedContract = ({ bytecode }: UnverifiedContractProps) => {
  const COLORS = useThemeColors()
  const { query, push } = useRouter()

  return (
    <>
      <Flex alignItems="center">
        <Text variant="title2medium">Contract creation code</Text>
        <Button
          ml="auto"
          size="small"
          loadingText="Verifying"
          onClick={() => {
            void push(Routes.contractVerification({ hash: query.hash as string }))
          }}
        >
          Verify & Publish
        </Button>
      </Flex>
      <Box
        mt={4}
        p={5}
        bgColor={COLORS.white}
        border="1px solid"
        maxH={200}
        overflow="auto"
        borderRadius={6}
        borderColor={COLORS.grey06}
      >
        <Text variant="text3mono" color={COLORS.grey01}>
          {bytecode}
        </Text>
      </Box>
    </>
  )
}
